import React from 'react';
import { DashboardStat, StatIcon } from '../callCenterDashboardTypes';
import styles from './StatCard.module.css';

interface StatCardProps {
  stat: DashboardStat;
}

const icons: Record<StatIcon, React.ReactNode> = {
  open: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2zm0-4H7V7h10v2z" />
    </svg>
  ),
  highPriority: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
  ),
  overdue: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
    </svg>
  ),
  resolved: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </svg>
  ),
};

export const StatCard: React.FC<StatCardProps> = ({ stat }) => {
  return (
    <div className={styles.card}>
      <div className={`${styles.iconBox} ${styles[`icon_${stat.color}`]}`}>
        {icons[stat.icon]}
      </div>
      <p className={styles.label}>{stat.label}</p>
      <p className={`${styles.value} ${styles[`value_${stat.color}`]}`}>{stat.value}</p>
    </div>
  );
};
